import {
  TCreatePracticeChartRequest,
  TPracticeChartListParams,
  TPracticeChartListResponse,
  TPracticeChartInfoResponse,
} from 'types/apis/chart/studentPracticeChart';
import { TChangeChartNameForm } from 'types/form/chart';
import { createService } from '../config/axios';
import qs from 'qs';

export const postPracticeChart = async (data: TCreatePracticeChartRequest) =>
  await createService({
    url: '/practice-chart',
    options: {
      method: 'post',
      data,
    },
  });

export const getPracticeChartList = async (
  params: TPracticeChartListParams
) => {
  const queryString = qs.stringify(params);
  const url = queryString
    ? `/practice-chart?${queryString}`
    : '/practice-chart';

  return await createService<TPracticeChartListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getPracticeChartInfo = async (
  practiceChartId: number,
  chartTypeNum: number
) =>
  await createService<TPracticeChartInfoResponse>({
    url: `/practice-chart/${practiceChartId}/${chartTypeNum}`,
    options: {
      method: 'get',
    },
  });

export const putPracticeChartInfo = async (
  practiceChartId: number,
  data: FormData
) =>
  await createService({
    url: `/practice-chart/${practiceChartId}`,
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'put',
      data,
    },
  });

export const patchPracticeChartName = async (
  practiceChartId: number,
  data: TChangeChartNameForm
) =>
  await createService({
    url: `/practice-chart/${practiceChartId}`,
    options: {
      method: 'patch',
      data,
    },
  });

export const deletePracticeChart = async (practiceChartId: number) =>
  await createService({
    url: `/practice-chart/${practiceChartId}`,
    options: {
      method: 'delete',
    },
  });
